//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <DIV class='content-wrapper'
   v-loading="loadingSpinner"
   element-loading-text="Подождите">

  <div v-if="serverData.loadingDataStatus.mainCommonData != serverData.loadingDataStatus.types.LOADED" class="loading-text">
    Подождите, загружаются общие данные
  </div>
  <div v-else-if="serverData.loadingDataStatus.events != serverData.loadingDataStatus.types.LOADED" class="loading-text">
    Подождите, загружаются данные по площадкам
  </div>
  <div v-else-if="event == null" style="width:100%; float:left">
    <div @click="close()"><i class="fas fa-arrow-circle-left back-button"></i></div>
    <div class="eventnotfound-text">Событие не найдено</div>
  </div>

  <div v-else-if="viewType == 2" class="select-places">

    <!--div vif2="isActiveUserAdmin()" class="select-place select-place-dashed-border">
      <div class="select-place-image" style="text-align:center">
        <router-link to="/place-edit" class="select-place-edit-link select-link">
          <i class="fas fa-plus-circle" style="font-size:48px;"></i><br><br>
          <span style="font-size:20px">Создать площадку</span>
        </router-link>
      </div>
      <div class="select-place-info" style="background:#D9E0E7">&nbsp;</div>
    </div-->

    <div style="width:100%; float:left">
      <i class="fas fa-arrow-circle-left back-button" style="width:52px; padding-left:7px" @click="viewType = 1"></i>
      <Input v-model="placesFilterValue" placeholder="Фильтр по названию или адресу" size="large" class="event-prop" style="width:calc(100% - 52px); padding-right:25px; float:right"/>
    </div>

    <div v-for="(place, key) in filteredPlaces" :key="place.val.id" @click="event.val.place = place.val.id; viewType = 1" class="select-place">

      <div class="select-place-image" :style="{'background-image': 'url(' + serverData.imagesGetURL(place.val.images[0]) + ')'}">
        &nbsp;
      </div>

      <DIV class="select-place-info">
      <div style="width:100%; padding:0px 0 0 0; float:left;">
        <div class="select-place-name">{{place.val.name}}</div>
      </div>

      <div style="width:100%; padding:10px 0 0 0; float:left;">
        <!--div class="select-place-prop">Адрес:</div-->
        <div class="select-place-prop" style="padding-top:3px">{{place.val.city}}, {{place.val.address}}</div>
      </div>
      </DIV>

    </div>

  </div>

  <div v-else-if="viewType == 1" class="event">

    <div id="eventimage1" class="event-image" :style="{'background-image': 'url(' + serverData.imagesGetURL(event.val.body.images[0]) + ')'}">
      <i class="fas fa-arrow-circle-left back-button-over" @click="close()"></i>
      <i class="fas fa-edit back-button-over-center" @click="$refs.uploadingFileRef1.click()"></i>
      <input type="file" ref="uploadingFileRef1" @change="uploadingFileOnChange(1)" class="input_file_hidden"/>
    </div>

    <div style="width:100%; padding:10px 0 0 0; float:left;">
      <div class="event-status" :style="{'background' : getEventStatusBackground()}" v-if="event.val.status != 1">
        {{getEventStatusText()}}<br>по причине: {{event.val.body.cancelReason}}
      </div>
    </div>

    <DIV class="event-props-block">                                                                          

    <div style="width:100%; padding:10px 0 0 0; text-align:left; float:left;">
      <div class="event-prop-title">Автор</div>
      <div class="event-prop link" @click="goToUserCard(event.val.createdBy)">
        <div class="event-prop-user-avatar" :style="{'background-image':  'url(' + serverData.imagesGetURL(serverData.usersMap[event.val.createdBy].body.avatar) + ')'}">&nbsp;</div>
        <div style="width:calc(100% - 44px); padding-top:10px; float:right">
          {{serverData.usersMap[event.val.createdBy].name}}<br>
        </div>
      </div>
    </div>

    <div v-if="isActiveUserAdmin()" style="width:100%; padding:0 0 0 0; text-align:left; float:left;">
      <div class="event-prop-title">Изменил</div>
      <div class="event-prop link" @click="goToUserCard(event.val.updatedBy)">
        <div class="event-prop-user-avatar" :style="{'background-image':  'url(' + serverData.imagesGetURL(serverData.usersMap[event.val.updatedBy].body.avatar) + ')'}">&nbsp;</div>
        <div style="width:calc(100% - 44px); padding-top:10px; float:right">
          {{serverData.usersMap[event.val.updatedBy].name}}<br>
        </div>
      </div>
    </div>

    <div style="width:100%; float:left;">
      <div class="event-prop-title">Название</div>
      <Input v-model="event.val.name" placeholder="Название" size="large" class="event-prop"/>
    </div>

    <div style="width:100%; float:left;">
      <div class="event-prop-title">Тэги</div>
      <Input v-model="event.val.tags" placeholder="Тэги" size="large" class="event-prop"/>
    </div>

    <div style="width:100%; float:left;">
      <div class="event-prop-title">Уровень</div>
      <InputNumber v-model="event.val.level" :min="1" :max="5" placeholder="Уровень" size="large" class="event-prop event-prop-inputnumber"/>
    </div>

    <div style="width:100%; float:left;">
      <div class="event-prop-title">Цена</div>
      <InputNumber v-model="event.val.price" :min="0" placeholder="Цена" size="large" class="event-prop event-prop-inputnumber"/>
    </div>

    <div style="width:100%; text-align:left; float:left;">
      <div class="event-prop-title">Место</div>
      <div v-if="event.val.place != null" class="event-prop event-prop-place" @click="viewType=2">
        <div class="event-prop-place-image" :style="{'background-image': 'url(' + serverData.imagesGetURL(serverData.placesMap[event.val.place].val.images[0]) + ')'}">&nbsp;</div>
        <div style="width:calc(100% - 35px); padding-top:8px; float:right">
          {{serverData.placesMap[event.val.place].val.name}}
        </div>
      </div>
      <div v-else class="event-prop event-prop-place" @click="viewType=2">
        <div style="width:100%; padding-top:8px; color:#bbb; float:right">Место события</div>
      </div>
    </div>

    <div style="width:100%; float:left;">
      <div class="event-prop-title">Дата старта</div>
      <DatePicker v-model="event.val.dateStart" type="date" placeholder="Дата старта" size="large" class="event-prop"></DatePicker>
    </div>

    <div style="width:100%; float:left;">
      <div class="event-prop-title">Время старта</div>
      <Input v-model="event.val.timeStart" format="HH:mm" :steps="[1, 15]" placeholder="Время окончания" size="large" class="event-prop"></Input>
      <!--TimePicker v-model="event.val.timeStart" format="HH:mm" :steps="[1, 15]" placeholder="Время старта" size="large" class="event-prop"></TimePicker-->
    </div>

    <div style="width:100%; float:left;">
      <div class="event-prop-title-doubleline">Дата<br>окончания</div>
      <DatePicker v-model="event.val.dateEnd" type="date" placeholder="Дата старта" size="large" class="event-prop"></DatePicker>
    </div>

    <div style="width:100%; float:left;">
      <div class="event-prop-title-doubleline">Время<br>окончания</div>
      <Input v-model="event.val.timeEnd" format="HH:mm" :steps="[1, 15]" placeholder="Время окончания" size="large" class="event-prop"></Input>
      <!--TimePicker v-model="event.val.timeEnd" format="HH:mm" :steps="[1, 15]" placeholder="Время окончания" size="large" class="event-prop"></TimePicker-->
    </div>

    <div style="width:100%; float:left;">
      <div class="event-prop-title-doubleline">Минимум участников</div>
      <InputNumber v-model="event.val.body.membersLimitFrom" :min="1" placeholder="Мин кол-во участников" size="large" class="event-prop event-prop-inputnumber"/>
    </div>

    <div style="width:100%; float:left;">
      <div class="event-prop-title-doubleline">Максимум участников</div>
      <InputNumber v-model="event.val.body.membersLimitTo" :min="1" placeholder="Макс кол-во участников" size="large" class="event-prop event-prop-inputnumber"/>
    </div>

    <div style="width:100%; float:left;">
      <div class="event-prop-title-doubleline">Ограничения<br>для участников</div>
      <Input v-model="event.val.body.membersLimits" placeholder="Ограничения для участников" size="large" class="event-prop"/>
    </div>

    <div style="width:100%; float:left;">
      <div class="event-prop-title">Описание</div>
      <Input v-model="event.val.description" placeholder="Описание" size="large" type="textarea" :rows="3" class="event-prop"/>
    </div>

    <div v-if="event.val.status != eventStatuses.BANNED_BY_ADMIN" style="width:100%; margin-top:0px; float:left">
      <Button type="primary" size="large" class="button button-primary" style="width:calc((100% - 10px - 4px) / 2); margin:30px 0 0 0"     @click="saveAndClose()">Сохранить</Button>
      <Button type="ghost"   size="large" class="button"                style="width:calc((100% - 10px - 4px) / 2); margin:30px 0 0 10px"  @click="close()"       >Не сохранять</Button>
    </div>

    <div v-if="event.val.id != null" style="width:100%; float:left;">
      <hr style="width:100%; float:left"/>

      <div class="event-prop-title" style="width:130px; padding: 6px 5px 0 0px; font-size:14px; color:#bbb; float:left">Причина снятия<br>с публикации</div>
      <Input v-model="event.val.body.cancelReason"
             placeholder="Причина снятия с публикации" size="large" class="event-prop" style="width:calc(100% - 130px); margin-top:2px; font-size:14px; float:left"
            :disabled="(event.val.status != eventStatuses.ACTIVE) && (isActiveUserAdmin() == false)"/>
      <Button v-if="event.val.status == eventStatuses.ACTIVE"
              type="ghost" size="small" class="button" style="width:200px; margin:10px 0 0 0; color:#bbb; float:right"
              @click="changeStatus('cancel')">Снять с публикации</Button>
      <Button v-if="((event.val.status == eventStatuses.CANCELLED_BY_ORG) || (event.val.status == eventStatuses.CANCELLED_BY_ADMIN)) && (event.val.createdBy == activeUser.id)"
              type="ghost" size="small" class="button" style="width:200px; margin:10px 0 0 0; color:#fff; background:#db3; float:right"
              @click="changeStatus('activate')">Опубликовать</Button>

      <div v-if="(activeUser.id != event.val.createdBy) && isActiveUserAdmin() && (event.val.status != eventStatuses.BANNED_BY_ADMIN)" style="width:100%; margin-top:10px; float:left">
        <Button type="ghost" size="small" class="button" style="width:200px; margin:0; background:#f66; color:#ddd; float:right" @click="changeStatus('ban')">Забанить событие</Button>
      </div>

      <div v-if="(activeUser.id != event.val.createdBy) && isActiveUserAdmin() && (event.val.status == eventStatuses.BANNED_BY_ADMIN)" style="width:100%; margin-top:10px; float:left">
        <Button type="ghost" size="small" class="button" style="width:200px; margin:0;; background:#f66; color:#ddd; float:right" @click="changeStatus('remove ban')">Снять бан</Button>
      </div>

    </div>

    </DIV>

  </div>

  </DIV>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

import async from 'async'

import serverData from '@/store/serverData'

import http from 'axios'
import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

import arrayTools from '../technical/arrayTools/arrayTools.js'

export default {
  components: { },
  props: ['id'],
  data () {
    return {
      eventId: null,
      event: null,
      uploadingFiles: {1: '', 2: '', 3: '', 4: '', 5: '', 6: ''}, // это не файлы которые пришли с записью из БД, это файлы загруженные пользователем в браузере на замену
      serverData: serverData, // to make access from UI template
      placesFilterValue: '',
      viewType: 1, // 0 - выбор события из предыдущих 1 - отображение основного редактора 2 - выбор места
      loadingSpinner: false,
      eventStatuses: {
        ACTIVE: 1, // событие открыто для подписки
        HAPPENED: 2,  // событие случилось
        NO_INTERES: 3, // событие не случилось, не набралось людей, не интересно
        CANCELLED_BY_ORG: 10,
        CANCELLED_BY_ADMIN: 11, // пользователь сможет изменить статус т снова опубликовать
        BANNED_BY_ADMIN: 12 // пользователь не сможет изменить статус
        // DELETED - не делаем, есть CANCELLED что тоже самое
      }
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'activeUser'
    ]),
    filteredPlaces: function () {
      var filtered = []
      // var startDate = new Date(Date.now())
      // startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0)

      var placesFilterValueLowerCase = this.placesFilterValue.toLowerCase()
      for (var i = 0; i < this.serverData.places.length; i++) {
        var place = this.serverData.places[i]
        var addPlace = false
        if (place.val.name.toLowerCase().indexOf(placesFilterValueLowerCase) >= 0) {
          addPlace = true
        } else if (place.val.address.toLowerCase().indexOf(placesFilterValueLowerCase) >= 0) addPlace = true
        if (addPlace) filtered.push(place)
      }

      arrayTools.sort(filtered, function (a, b) {
        var res = a.val.name.toLowerCase().localeCompare(b.val.name.toLowerCase())
        if (res === 0) return false
        if (res > 0) return true; else return false
      })

      return filtered
    }
  },
  created: function () {
    var thisRef = this
    // загружаем данные, когда представление создано и данные реактивно отслеживаются
    this.getEventData()
    // подписываемся на загрузку основных данных - когда эта страница это та на которой стартует приложение и на момент created данные еще не подгрузились
    serverData.eventsBus.$on('mainCommonDataLoaded', this.getEventData)
    // на realtime обновления events подписываемся на случай если кто-то обновил именно этого места
    serverData.eventsBus.$on('eventsChanged', function (data) {
      // вызов этого обработчика будет и пока грузятся основные данные через mainCommonDataLoader что уже обрабатывается
      // через подписку на $on('mainCommonDataLoaded') и второй обработки events нам не надо
      if (data.initiator === 'realtimeServerDataManager') thisRef.getEventData(data)
    })
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова. а если сначала смотрели /event/1, ушли, и снова смотрим но /event/2 то кроме как через watch route больше об этом не узнать
    // !!!!!! И ВАЖНО ПОМНИТЬ: этот роутер будет вызываться вообще всегда даже когда ходишь по эвентам. поэтому проверку надо на router.path иrouter.name
    $route: 'getEventData'
  },
  methods: {
    // data - это может быть null если при create
    // может быть объект из realtimeServerDataManager  {method:'update', record:{id, name...}, initiator: "realtimeServerDataManager"}
    // а может быть объект route из watch route.
    // примеры
    //   {name:'event', path:'/event-edit/1', params:{id:1}}
    //   {name:'event-edit-new', path:'/event-edit', params:{}}
    //   {name:'event-edit-new', path:'/event-edit', params:{}}
    // console.log(this.$router.app._route.name)
    getEventData (data) {
      // console.log('----------------')
      // console.log('getEventEditData')
      // console.log(data)
      // if (data != null) console.log(data.name)
      // if (data != null) console.log(data.path)
      if ((data != null) && (data.path != null) && ((data.name !== 'event-edit') && (data.name !== 'event-edit-new'))) return // на случай если это вызов через watch route когда ушли со страницы и тут так проверяем: если есть data.path значит data это роутер а не дата из realtime и если новый data.name("event", "events" etc) то уже выходим
      if ((data != null) && (data.record != null) && (data.record.id !== this.eventId)) return // другие типы объектов кроме event не придут. и тут на случай если пришло через realtimeServerDataManager обновление но объект с другим id
      if (this.activeUser == null) { this.$router.push('/pageForbidden'); return } // незалогинных долой
      // console.log('getEventEditData processing')
      this.eventId = this.id
      if (this.eventId != null) {
        if (typeof this.eventId === 'string') this.eventId = parseInt(this.eventId)
        var anEvent = serverData.eventsMap[this.eventId]
        if (anEvent == null) { /* console.log('EventEdit.getEventData: common data not loaded. exit'); */ return } // это происходит при перезагрузки страницы, данные еще не пришли с сервера
      } else {
        anEvent = restResource(this.appSettings.server.eventResource)
        anEvent.val = {
          name: '',
          tags: '',
          status: 1, // 1 - ACTIVE. событие открыто для подписки
          createdBy: this.activeUser.id,
          updatedBy: this.activeUser.id,
          level: 1,
          price: 0, // бесплатно
          place: null,
          placeToMeet: null,
          dateStart: new Date(Date.now()),
          timeStart: '12:00',
          dateEnd: new Date(Date.now()),
          timeEnd: '12:00',
          description: '',
          deleted: false,
          body: {
            images: [],
            paymentsTypes: [1, 2],
            deadlineToUnsub: 0,
            membersLimitFrom: 1,
            membersLimitTo: 10,
            membersLimits: ''
          }
        }
      }
      // сначала мы все проверяем, а потом устнавливаем this.event, иначе на экране мелькание - сначала отрисовка экрана ибо по this.event отрабатывает view а потом forbidden страница
      if ((this.id != null /* не создание нового эвента а редактирование */) && (this.isActiveUserOwnerOfEventOrAdmin(anEvent) === false)) { this.$router.push('/pageForbidden'); return }
      this.eventTimeStartToEdit = anEvent.val.timeStart
      console.log(this.eventTimeStartToEdit)
      // this.eventTimeEndToEdit = anEvent.val.timeEnd
      this.event = Object.assign({}, anEvent)
      this.event.val = Object.assign({}, anEvent.val)
        // this.event.val.images = Object.assign({}, anEvent.val.images)
      // console.log('getEventEditData end')
      this.viewType = 1 // если заново зашли в редактирование события то должно показываться событие а не список мест или еще чего
    },
    isActiveUserOwnerOfEventOrAdmin (event) {
      if (this.activeUser == null) return false
      if (this.activeUser.id === event.val.createdBy) return true // если activeUser это орг события
      if ((this.activeUser.group === 0) || (this.activeUser.group === 1) || (this.activeUser.group === 2)) return true // суперпользователь или админ или модератор
      return false
    },
    isActiveUserAdmin (event) {
      if (this.activeUser == null) return false
      if ((this.activeUser.group === 0) || (this.activeUser.group === 1) || (this.activeUser.group === 2)) return true // суперпользователь или админ или модератор
      return false
    },
    goToUserCard (id) {
      this.$router.push({name: 'user', params: {id: id}})
    },
    close () {
      if ((this.$router.app._route.name !== 'event-edit') && (this.$router.app._route.name !== 'event-edit-new')) return // это значит что уже перешли куда-то типа event-edit и это close лишнее с обработки картинки а не иконки назад и history.back делать не надо
      // 2 - это значит пустая страница + текущая с продуктом. или 1 - сразу из внешнего приложения открылась эта страница
      if (history.length <= 2) window.location.href = '/' // !!! проверить
      else history.back() // this.$router.go(-1)
    },
    uploadingFileOnChange (fileIndx, file) {
      // забираем себе объект готового к загрузке файла
      if (file != null) this.uploadingFiles[fileIndx] = file
      else this.uploadingFiles[fileIndx] = this.$refs['uploadingFileRef' + fileIndx].files[0]

      if (this.uploadingFiles[fileIndx]) {
        // меняем картинку редактируемого fileEntity
        var reader = new FileReader()
        reader.onload = function (e) {
          var el = document.getElementById('eventimage' + fileIndx)
          el.style.backgroundImage = 'url(' + e.target.result + ')'
        }
        reader.readAsDataURL(this.uploadingFiles[fileIndx])
      }
    },
    saveImage (fileIndx, cb) {
      if (this.uploadingFiles[fileIndx] === '') return cb()
      let formData = new FormData()
      if (this.event.val.body.images[fileIndx - 1] != null) formData.append('id', this.event.val.body.images[fileIndx - 1]) // если заменяем файл, то вносим fileEntity id
      formData.append('name', this.uploadingFiles[fileIndx].name.trim()) // !!! еще укоротить название? - защита от хакеров?
      formData.append('container', 'events')
      formData.append('_data', this.uploadingFiles[fileIndx])

      http.post(this.appSettings.server.fileEntityResource + '/storeFileByFormData/', formData, {headers: {'Content-Type': 'multipart/form-data'}})
      .then(function (response) {
        return cb(null, response) // здесь из data берем fileEntity и из нее id для обновления данных images в записи product
      })
      .catch(function (err) { return cb(err) })
    },
    saveAndClose () {
      if ((this.eventId == null) && (this.uploadingFiles[1] === '')) return this.$message.error('Загрузите картинку события') // для новых создаваемых - нельзя без картинки
      if (this.event.val.name.length < 6) return this.$message.error('Слишком короткое название')
      if (this.event.val.place == null) return this.$message.error('Выберите место события')

      this.event.val.updatedBy = this.activeUser.id
      console.log(this.event.val.timeStart)

      var thisRef = this

      thisRef.loadingSpinner = true
      const loading = thisRef.$loading({
        lock: true,
        text: 'Подождите, идет сохранение данных'
      })

      async.parallel({
        file1: function (asyncCallback) {
          thisRef.saveImage(1, function (err, response) {
            if ((err == null) && (response != null)) thisRef.event.val.body.images[0] = response.data.id
            asyncCallback(err)
          })
        },
        file2: function (asyncCallback) {
          thisRef.saveImage(2, function (err, response) {
            if ((err == null) && (response != null)) thisRef.event.val.body.images[1] = response.data.id
            asyncCallback(err)
          })
        },
        file3: function (asyncCallback) {
          thisRef.saveImage(3, function (err, response) {
            if ((err == null) && (response != null)) thisRef.event.val.body.images[2] = response.data.id
            asyncCallback(err)
          })
        },
        file4: function (asyncCallback) {
          thisRef.saveImage(4, function (err, response) {
            if ((err == null) && (response != null)) thisRef.event.val.body.images[3] = response.data.id
            asyncCallback(err)
          })
        },
        file5: function (asyncCallback) {
          thisRef.saveImage(5, function (err, response) {
            if ((err == null) && (response != null)) thisRef.event.val.body.images[4] = response.data.id
            asyncCallback(err)
          })
        },
        file6: function (asyncCallback) {
          thisRef.saveImage(6, function (err, response) {
            if ((err == null) && (response != null)) thisRef.event.val.body.images[5] = response.data.id
            asyncCallback(err)
          })
        }
      }, function (error) {
        if (!error) {
          thisRef.event.save()
          .then(function () {
            thisRef.loadingSpinner = false
            loading.close()

            // thisRef.event = null
            thisRef.uploadingFiles = {1: '', 2: '', 3: '', 4: '', 5: '', 6: ''}

            // thisRef.$message.success('Сохранено')
            thisRef.close()
          })
          .catch(function (err) {
            thisRef.loadingSpinner = false
            loading.close()
            serverErrorHandling(err, thisRef)
          })
        } else {
          thisRef.loadingSpinner = false
          loading.close()
          if ((error.response != null) && (error.response.data != null) && (error.response.data.code === 1101)) thisRef.$message.error('Слишком большой размер файла')
          else serverErrorHandling(error, thisRef)
        }
      })
    },
    changeStatus (action) {
      if (this.event.val.id == null) return this.$message.error('Новое событие нельзя снимать с публикации')
      if ((action !== 'activate') && (this.event.val.body.cancelReason == null)) return this.$message.error('Напишите причину')
      if ((action !== 'activate') && (this.event.val.body.cancelReason.length < 6)) return this.$message.error('Напишите причину')
      if ((action !== 'activate') && (this.event.val.body.cancelReason.length > 50)) return this.$message.error('Слишком длинная причина')

      var statusBackup = this.event.val.status
      this.event.val.updatedBy = this.activeUser.id
      if (this.event.val.createdBy === this.activeUser.id) { // автор
        if (action === 'activate') this.event.val.status = this.eventStatuses.ACTIVE
        else if (action === 'cancel') this.event.val.status = this.eventStatuses.CANCELLED_BY_ORG
        else {
          this.$error('Не выполнено')
          return
        }
      } else if (this.isActiveUserAdmin()) {  // superadmins, admins, moderators
        if (action === 'cancel') this.event.val.status = this.eventStatuses.CANCELLED_BY_ADMIN
        else if (action === 'ban') this.event.val.status = this.eventStatuses.BANNED_BY_ADMIN
        else if (action === 'remove ban') this.event.val.status = this.eventStatuses.CANCELLED_BY_ADMIN
        else {
          this.$error('Не выполнено')
          return
        }
      } else {
        this.$error('Не выполнено')
        return
      }

      var thisRef = this

      thisRef.loadingSpinner = true
      const loading = thisRef.$loading({
        lock: true,
        text: 'Подождите, идет сохранение данных'
      })

      http.post(this.appSettings.server.eventChangeStatus, thisRef.event.val)
      .then(function () {
        thisRef.loadingSpinner = false
        loading.close()
        // thisRef.event = null
        // thisRef.$message.success('Сохранено')
        thisRef.close()
      })
      .catch(function (err) {
        thisRef.event.val.status = statusBackup
        thisRef.loadingSpinner = false
        loading.close()
        serverErrorHandling(err, thisRef)
      })
    },
    getEventStatusText () {
      switch (this.event.val.status) {
        case 1: return 'Опубликовано'
        case 10: return 'Снято с публикации автором'
        case 11: return 'Снято с публикации админом'
        case 12: return 'Событие ЗАБАНЕННО админом'
        default: return 'Неизвестный статус события'
      }
    },
    getEventStatusBackground () {
      switch (this.event.val.status) {
        case 1: return '#888'
        case 10: return '#db3'
        case 11: return '#d33'
        case 12: return '#f00'
        default: return '#f00'
      }
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  width: 100%;
  margin: 0px 0px 0px 0px;
  padding: 0px;
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
}
.back-button {
  width: 100%;
  font-size: 35px;
  color: #777;
  padding: 10px 10px 10px 15px;
  cursor: pointer;
  float: left;
}
.back-button-over {
  width: 50px;
  position: relative;
  top: 5px;
  left: 7px;
  font-size: 35px;
  /* color: #888; */
  color: #fff;
  text-shadow: -1px 0 #777, 0 1px #777, 1px 0 #777, 0 -1px #777;
  cursor: pointer;
  float: left;
}
.back-button-over-center {
  width: 50px;
  position: relative;
  top: calc(66vw - 100px);
  left: calc((100vw / 2) - 63px);
  font-size: 35px;
  /* color: #888; */
  color: #fff;
  text-shadow: -1px 0 #777, 0 1px #777, 1px 0 #777, 0 -1px #777;
  cursor: pointer;
  float: left;
}
/*@media screen and (min-width: 606px) { *//* 606 это когда высота 66vw начинает ограничиваться 400px*/
/*  .back-button-over-center {
    top: 300px;
  }
}*/
@media screen and (min-width: 600px) {
  .back-button-over {
    /* color: #888;
    text-shadow: 0 0 #fff; */
  }
  .back-button-over-center {
    top: 350px;
    left: 235px;
  }
}
.loading-text {
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
  font-size: 20px;
  padding: 20px 20px 20px 20px;
}
.eventnotfound-text {
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  font-size: 20px;
  padding: 20px 20px 20px 20px;
}
.event {
  width: 100%;
  margin-left: 0%;
  padding-bottom: 40px;
  text-align: left;
  float:left;
}
.event-image {
  width: 100%;
  height: 66vw;
  max-height: 400px;
  background: #333;
  background-size: cover;
  background-position: center;
  border-radius: 20px 20px 0 0;
  border-bottom: solid 1px #e0e0e0;
  cursor: default;
  float: left;
}
@media screen and (min-width: 600px) { /* 606 это когда высота 66vw начинает ограничиваться 400px*/
  .event {
    width: 600px;
    margin-left: calc((100% - 600px) / 2);
  }
  .event-image {
    width: 600px;
    height: 450px;
    max-height: 450px;
    margin-top: 0px;
    margin-left: 0px;
    border-radius: 20px;
    border: solid 1px #e0e0e0;
  }
  .event-status {
    text-align: center;
  }
}
.event-props-block {
  width: 100%;
  padding: 0 25px 0 25px;
}
.event-status {
  width: calc(100% - 50px);
  margin: 0px 25px 0 25px;
  padding: 5px 5px 5px 5px;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 16px;
  background: #d33;
  color: #fff;
  border-radius: 8px 8px 8px 8px;
  float: left;
}
.event-prop-title {
  width: 130px;
  padding: 18px 0px 0px 0px;
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 14px;
  float:left;
}
.event-prop-title-doubleline {
  width: 130px;
  padding: 10px 0px 0px 0px;
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 14px;
  float:left;
}
.event-prop {
  width: calc(100% - 130px);
  margin: 7px 0px 0px 0px;
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 14px;
  float:left;
}
.event-prop-inputnumber {
  font-size: 14px;
}
.event-prop-place {
  height: 36px;
  border: 1px solid #ddd;
  padding: 3px 7px 0 7px;
  border-radius: 4px;
  cursor: pointer;
}
.event-prop-place:hover {
  border: 1px solid #9090c0;
}
.event-prop-place-image {
  width: 28px;
  height: 28px;
  margin-right: 7px;
  background: #555;
  background-size: cover;
  background-position: center;
  border-radius: 4px;
  border: solid 1px #e0e0e0;
  float: left;
}
.event-prop-user-avatar {
  width: 30px;
  height: 30px;
  margin-left: 7px;
  margin-right: 7px;
  background: #555;
  background-size: cover;
  background-position: center;
  border-radius: 15px;
  border: solid 1px #e0e0e0;
  float: left;
}
.text-align-left {
  text-align:left;
}
.text-align-right {
  text-align:right;
}
.button{
  border-radius: 15px;
  font-size: 16px;
}
.button-primary{
  /*background: #6770a6;*/
  background: #6070dd;
}
.input_file_hidden{
  position: absolute;
  top: -500px;
}
.link {
  cursor: pointer;
}
.link:hover {
  color: #78b;
}
hr {
  margin: 40px 0 40px 0;
}
/****************************************************************************/
.select-places {
  width: 100%;
  margin-left: 0%;
  padding-left: 25px;
  padding-bottom: 0px;
  text-align: left;
  float:left;
}
.select-place {
  width: calc((100% - 50px) / 2);
  margin: 0px 25px 25px 0px;
  cursor: pointer;
  float:left;
}
/* .select-place-dashed-border {
  margin: 0 24px 21px 1px;
  border: 2px dashed #ccc;
  border-radius: 20px;
  cursor:default
}
.select-place-edit-link {
  width:200px;
  margin:200px 0 0 calc((100% - 200px) / 2);
  float:left;
} */
@media screen and (min-width: 600px) {
  .select-places {
    width: 600px;
    margin-left: calc((100% - 600px) / 2);
  }
  /* .select-place-dashed-border {
    max-height: 200px;
  }
  .select-place-edit-link {
    margin-top: 50px;
  } */
}
/*.select-link {
  color: #778 !important;
  text-decoration: none !important;
  cursor: pointer !important;
}
.select-link:hover {
  color: #808aa0 !important;
  text-decoration: none !important;
} */
.select-place-image {
  width: 100%;
  height: 150px;
  background-size: cover;
  background-position: center;
  border-radius: 20px 20px 0px 0px;
  border-top: solid 1px #ccc;
  border-bottom: solid 0px #ccc;
  border-left: solid 1px #ccc;
  border-right: solid 1px #ccc;
  float: left;
}
.select-place-info {
  width: 100%;
  height: 165px;
  padding: 0;
  background: #fff;
  border-radius: 0px 0px 20px 20px;
  border-top: solid 0px #ccc;
  border-bottom: solid 1px #ccc;
  border-left: solid 1px #ccc;
  border-right: solid 1px #ccc;
  float: left;
}
@media screen and (min-width: 600px) {
.select-place-image {
  height: 225px;
}
.select-place-info {
  width: 100%;
  height: 145px;
}
}
.select-place-name {
  /* position: relative;
  top: calc(100% - 95px);
  z-index: 2;
  padding: 13px 35px 17px 12px;
  opacity: 0.85;
  background: #fff;
  color: #222; */
  padding: 10px 25px 0px 25px;
  color: #222;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 14px;
  float:left;
}
.select-place-prop {
  width: 100%;
  padding: 7px 25px 0px 25px;
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 13px;
  float:left;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// EventEdit.vue?6bb28d57